module.exports = __webpack_public_path__ + "static/media/wrong-01.e114dc6e.png";